module.exports = __webpack_public_path__ + "static/media/selected_seaplaneport_marker.366aebf4.svg";